webpackJsonp([35783957827783],{

/***/ 69:
/***/ (function(module, exports) {

	module.exports = function (string) {
	  return string.charAt(0).toUpperCase() + string.substring(1);
	}
	
	module.exports.words = function (string) {
	  return string.replace(/(^|[^a-zA-Z\u00C0-\u017F'])([a-zA-Z\u00C0-\u017F])/g, function (m) {
	    return m.toUpperCase()
	  })
	}


/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n@media (min-device-width:416px) and (orientation: portrait){\n  display:none;\n}\n'], ['\n@media (min-device-width:416px) and (orientation: portrait){\n  display:none;\n}\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _presets = __webpack_require__(4);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _typography = __webpack_require__(3);
	
	var _Background = __webpack_require__(15);
	
	var _Background2 = _interopRequireDefault(_Background);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var BackgroundMobile = _Background2.default.extend(_templateObject);
	
	exports.default = BackgroundMobile;
	module.exports = exports['default'];

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n@media (max-device-width:417px) and (orientation: portrait){\n  display: block;\n}\n@media (min-device-width:2050px) and (orientation: portrait){\n  display:none;\n}\n'], ['\n@media (max-device-width:417px) and (orientation: portrait){\n  display: block;\n}\n@media (min-device-width:2050px) and (orientation: portrait){\n  display:none;\n}\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _presets = __webpack_require__(4);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _typography = __webpack_require__(3);
	
	var _Background = __webpack_require__(15);
	
	var _Background2 = _interopRequireDefault(_Background);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var BackgroundTablet = _Background2.default.extend(_templateObject);
	
	exports.default = BackgroundTablet;
	module.exports = exports['default'];

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n@media (min-device-width:0) and (orientation: landscape){\n  display: block;\n  color:green;\n}\n@media (min-device-width:0) and (orientation: portrait){\n  display:none;\n}\n'], ['\n@media (min-device-width:0) and (orientation: landscape){\n  display: block;\n  color:green;\n}\n@media (min-device-width:0) and (orientation: portrait){\n  display:none;\n}\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _presets = __webpack_require__(4);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _typography = __webpack_require__(3);
	
	var _Background = __webpack_require__(15);
	
	var _Background2 = _interopRequireDefault(_Background);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var BackgroundWideScreen = _Background2.default.extend(_templateObject);
	
	exports.default = BackgroundWideScreen;
	module.exports = exports['default'];

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  0% {\n    background-position: 0 0;\n  }\n  100% {\n    background-position: 100px 0;\n  }\n'], ['\n  0% {\n    background-position: 0 0;\n  }\n  100% {\n    background-position: 100px 0;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: inline-block;\n  position:relative;\n  ', '\n  padding: ', ' ', ';\n  background-color: ', ';\n  font-family: ', ';\n  text-transform: uppercase;\n  line-height: 1;\n  ::before{content:"";}\n  ::after{content:"";}\n  ', '\n  :hover{\n    ', '\n    background-color: ', ';\n  }\n'], ['\n  display: inline-block;\n  position:relative;\n  ', '\n  padding: ', ' ', ';\n  background-color: ', ';\n  font-family: ', ';\n  text-transform: uppercase;\n  line-height: 1;\n  ::before{content:"";}\n  ::after{content:"";}\n  ', '\n  :hover{\n    ', '\n    background-color: ', ';\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position:relative;\n  ', '\n  display:inline-block;\n\n'], ['\n  position:relative;\n  ', '\n  display:inline-block;\n\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position:relative;\n  ', '\n  display:block;\n  ', '\n  box-sizing: content-box;\n'], ['\n  position:relative;\n  ', '\n  display:block;\n  ', '\n  box-sizing: content-box;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  background-image: linear-gradient(\n    ', ',\n    ', ' 25%,\n    transparent 25%,\n    transparent 50%,\n    ', ' 50%,\n    ', ' 75%,\n    transparent 75%,\n    transparent\n    );\n  background-size: ', ' ', ';\n  animation: ', ' 1.8s infinite linear forwards;\n  animation-fill-mode: none;\n\n  position:absolute;\n  display:block;\n  top:', ';\n  left:100%;\n  right:0;\n  bottom:0;\n  height:50%;\n  width:', ';\n  border-radius: 0 ', ' 0 0 ;\n\n'], ['\n  background-image: linear-gradient(\n    ', ',\n    ', ' 25%,\n    transparent 25%,\n    transparent 50%,\n    ', ' 50%,\n    ', ' 75%,\n    transparent 75%,\n    transparent\n    );\n  background-size: ', ' ', ';\n  animation: ', ' 1.8s infinite linear forwards;\n  animation-fill-mode: none;\n\n  position:absolute;\n  display:block;\n  top:', ';\n  left:100%;\n  right:0;\n  bottom:0;\n  height:50%;\n  width:', ';\n  border-radius: 0 ', ' 0 0 ;\n\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _presets = __webpack_require__(4);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _typography = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var radius = (0, _typography.rhythm)(0.1);
	var stripecolor = "#e1ff00";
	
	var movebg = (0, _styledComponents.keyframes)(_templateObject);
	
	var Cta = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject2, '' /* box-sizing: border-box; */, (0, _typography.rhythm)(0.4), (0, _typography.rhythm)(0.5), _presets2.default.brand, _presets2.default.brandFontFamily, _presets2.default.shadowMed, _presets2.default.shadowLow, _presets2.default.brand);
	
	var Container = _styledComponents2.default.div(_templateObject3, '' /* overflow:hidden; */);
	var Wrapper = _styledComponents2.default.div(_templateObject4, '' /* overflow:hidden; */, '' /* padding:${rhythm(0.2)}; */);
	
	var Stripes = _styledComponents2.default.div(_templateObject5, function (props) {
	  return props.bottom ? '-45deg' : '45deg';
	}, stripecolor, stripecolor, stripecolor, (0, _typography.rhythm)(0.5), (0, _typography.rhythm)(0.5), movebg, function (props) {
	  return props.bottom ? '50%' : '0';
	}, (0, _typography.rhythm)(0.5), (0, _typography.rhythm)(0.5));
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(
	        Cta,
	        { to: props.to },
	        props.children
	      ),
	      _react2.default.createElement(Stripes, null),
	      _react2.default.createElement(Stripes, { bottom: true })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: grid;\n  grid-auto-flow: row;\n  grid-template-columns: repeat(auto-fill, minmax(', ', 1fr));\n  grid-auto-rows: ', ';\n  grid-gap: ', ';\n\n  width:calc(100% - ', ');\n  max-width:', ';\n  margin:0 auto;\n  margin-bottom: ', ';\n  ', '\n  a{\n    ', '\n    font-size: 0.8rem;\n    div{\n      height:100%;\n      width:100%;\n    }\n    background-color: unset;\n  }\n  p{\n    position:absolute;\n    bottom:0;\n    font-weight:400;\n    padding-right: ', ';\n    margin-bottom: ', ';\n  }\n\n\n  @media screen and ', '{\n    grid-template-columns: repeat(auto-fill, minmax(', ', 1fr));\n    grid-auto-rows: ', ';\n  }\n\n  @media screen and ', '{\n    grid-template-columns: repeat(auto-fill, minmax(', ', 1fr));\n    grid-auto-rows: ', ';\n  }\n\n  @media screen and ', '{\n    grid-template-columns: repeat(auto-fill, minmax(', ', 1fr));\n    grid-auto-rows: ', ';\n  }\n\n  ', '\n'], ['\n  display: grid;\n  grid-auto-flow: row;\n  grid-template-columns: repeat(auto-fill, minmax(', ', 1fr));\n  grid-auto-rows: ', ';\n  grid-gap: ', ';\n\n  width:calc(100% - ', ');\n  max-width:', ';\n  margin:0 auto;\n  margin-bottom: ', ';\n  ', '\n  a{\n    ', '\n    font-size: 0.8rem;\n    div{\n      height:100%;\n      width:100%;\n    }\n    background-color: unset;\n  }\n  p{\n    position:absolute;\n    bottom:0;\n    font-weight:400;\n    padding-right: ', ';\n    margin-bottom: ', ';\n  }\n\n\n  @media screen and ', '{\n    grid-template-columns: repeat(auto-fill, minmax(', ', 1fr));\n    grid-auto-rows: ', ';\n  }\n\n  @media screen and ', '{\n    grid-template-columns: repeat(auto-fill, minmax(', ', 1fr));\n    grid-auto-rows: ', ';\n  }\n\n  @media screen and ', '{\n    grid-template-columns: repeat(auto-fill, minmax(', ', 1fr));\n    grid-auto-rows: ', ';\n  }\n\n  ', '\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(14);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _presets = __webpack_require__(4);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _typography = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// const tile = presets.blogTileSize;
	// const tile = rhythm(5);
	var mobileTile = "12em";
	var phabletTile = "10em";
	var tabletPorTile = "12em";
	var tabletLanTile = "12em";
	// we didn't need the rest of these presets:
	// const desktopTile = "120px" ;
	// const hdTile = "120px" ;
	// const vhdTile = "120px" ;
	// const vvhdTile = "120px" ;
	// const fourk = "120px" ;
	
	var SeeGrid = _styledComponents2.default.div(_templateObject, mobileTile, mobileTile, (0, _typography.rhythm)(1), (0, _typography.rhythm)(2), (0, _typography.rhythm)(28), (0, _typography.rhythm)(1.5), '' /* repeat(number of columns/rows, the column width we want); */, _presets2.default.shadowLow, (0, _typography.rhythm)(0.5), (0, _typography.rhythm)(0.5), _presets2.default.phablet.por, phabletTile, phabletTile, _presets2.default.tablet.por, tabletPorTile, tabletPorTile, _presets2.default.tablet.lan, tabletLanTile, tabletLanTile, '' /* @media screen and ${presets.desktop.lan}{
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          }
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          @media screen and ${presets.hd.lan}{
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          }
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          @media screen and ${presets.vhd.lan}{
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          }
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          @media screen and ${presets.vvhd.lan}{
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          } */);
	exports.default = SeeGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyImage = __webpack_require__(14);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _typography = __webpack_require__(3);
	
	var _capitalize = __webpack_require__(69);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _Section = __webpack_require__(26);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Background = __webpack_require__(15);
	
	var _Background2 = _interopRequireDefault(_Background);
	
	var _BackgroundMobile = __webpack_require__(113);
	
	var _BackgroundMobile2 = _interopRequireDefault(_BackgroundMobile);
	
	var _BackgroundTablet = __webpack_require__(114);
	
	var _BackgroundTablet2 = _interopRequireDefault(_BackgroundTablet);
	
	var _BackgroundWideScreen = __webpack_require__(115);
	
	var _BackgroundWideScreen2 = _interopRequireDefault(_BackgroundWideScreen);
	
	var _Crosshairs = __webpack_require__(25);
	
	var _Crosshairs2 = _interopRequireDefault(_Crosshairs);
	
	var _Content = __webpack_require__(24);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Title = __webpack_require__(28);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _Tag = __webpack_require__(27);
	
	var _Tag2 = _interopRequireDefault(_Tag);
	
	var _P = __webpack_require__(46);
	
	var _P2 = _interopRequireDefault(_P);
	
	var _Ul = __webpack_require__(66);
	
	var _Ul2 = _interopRequireDefault(_Ul);
	
	var _BlogGallery = __webpack_require__(86);
	
	var _BlogGallery2 = _interopRequireDefault(_BlogGallery);
	
	var _BlogTile = __webpack_require__(87);
	
	var _BlogTile2 = _interopRequireDefault(_BlogTile);
	
	var _Cta = __webpack_require__(40);
	
	var _Cta2 = _interopRequireDefault(_Cta);
	
	var _CtaAnimated = __webpack_require__(277);
	
	var _CtaAnimated2 = _interopRequireDefault(_CtaAnimated);
	
	var _SeeGrid = __webpack_require__(116);
	
	var _SeeGrid2 = _interopRequireDefault(_SeeGrid);
	
	var _H = __webpack_require__(45);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _H3 = __webpack_require__(65);
	
	var _H4 = _interopRequireDefault(_H3);
	
	var _presets = __webpack_require__(4);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _mirage = __webpack_require__(727);
	
	var _mirage2 = _interopRequireDefault(_mirage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var _React$createElement;
	
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        data.site.siteMetadata.tag,
	        ' | ',
	        data.site.siteMetadata.title
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: 'We make awesome computer generated videos and images.' }),
	      _react2.default.createElement('meta', { property: 'og:title', content: data.site.siteMetadata.title }),
	      _react2.default.createElement('meta', { property: 'og:description', content: data.site.siteMetadata.description }),
	      _react2.default.createElement('meta', { property: 'og:url', content: data.site.siteMetadata.url }),
	      _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	      _react2.default.createElement('meta', { property: 'og:image', content: '' + data.site.siteMetadata.url + data.og.resize.src }),
	      _react2.default.createElement('meta', { property: 'og:image:width', content: data.og.resize.width }),
	      _react2.default.createElement('meta', { property: 'og:image:height', content: data.og.resize.height }),
	      _react2.default.createElement('meta', { property: 'og:image:alt', content: 'Awesome Computer Generated Imagery' }),
	      _react2.default.createElement('meta', { property: 'og:image:secure_url', content: '' + data.site.siteMetadata.url + data.og.resize.src }),
	      _react2.default.createElement('meta', { property: 'og:site_name', content: data.site.siteMetadata.title }),
	      _react2.default.createElement('meta', { property: 'og:locale', content: 'en_GB' }),
	      _react2.default.createElement('meta', { property: 'og:locale:alternate', content: 'en_US' })
	    ),
	    _react2.default.createElement(
	      _Section2.default,
	      null,
	      _react2.default.createElement(
	        _Background2.default,
	        null,
	        _react2.default.createElement(
	          'video',
	          (_React$createElement = { preload: 'auto', muted: 'true' }, _React$createElement['muted'] = true, _React$createElement.autoPlay = true, _React$createElement.loop = true, _React$createElement.playsInline = true, _React$createElement.poster = data.poster.resize.src, _React$createElement),
	          _react2.default.createElement('source', { src: _mirage2.default, type: 'video/mp4' }),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Your browser does not support the video tag.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Content2.default,
	        null,
	        _react2.default.createElement(
	          _H2.default,
	          { light: true },
	          'we make awesome imagery'
	        ),
	        _react2.default.createElement(
	          _P2.default,
	          { brand: true },
	          '3D computer generated videos and photo-realistic images to show off your brand, products and services from a UK-based VFX studio.'
	        ),
	        _react2.default.createElement(
	          _Tag2.default,
	          null,
	          'attention-grabbing visual content for your online experiences, landing pages, website and exhibitions.'
	        ),
	        _react2.default.createElement(
	          _Cta2.default,
	          { to: '/contact/' },
	          'let\'s talk.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _H4.default,
	      { style: { textAlign: 'center' } },
	      'stuff we\'ve made'
	    ),
	    _react2.default.createElement(
	      _SeeGrid2.default,
	      { id: 'stuff-we-made' },
	      data.allSeeYaml.edges.map(function (_ref2) {
	        var node = _ref2.node;
	        return _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            key: node.id,
	            to: '' + node.fields.slug,
	            style: { position: 'relative' },
	            alt: node.title, title: node.title },
	          _react2.default.createElement(_gatsbyImage2.default, {
	            sizes: node.image.childImageSharp.sizes,
	            alt: node.title
	          }),
	          _react2.default.createElement(
	            _Tag2.default,
	            null,
	            node.title
	          ),
	          node.video != null ? _react2.default.createElement(
	            _P2.default,
	            {
	              style: {
	                position: 'absolute',
	                top: '0',
	                left: '0',
	                fontSize: '' + (0, _typography.rhythm)(0.5),
	                marginTop: '' + (0, _typography.rhythm)(0.25),
	                marginLeft: '' + (0, _typography.rhythm)(0.25)
	              } },
	            '\u25B6[video]'
	          ) : ""
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'center' } },
	      _react2.default.createElement(
	        _Cta2.default,
	        { to: '/see/' },
	        'see more'
	      )
	    ),
	    _react2.default.createElement(
	      _Content2.default,
	      null,
	      _react2.default.createElement(
	        _H2.default,
	        null,
	        'what else?'
	      ),
	      _react2.default.createElement(
	        _Ul2.default,
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'awesome landing page code, a bit like this one'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'concept design'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'graphic design'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'branding & identity design'
	        )
	      ),
	      _react2.default.createElement(
	        _Tag2.default,
	        null,
	        'We\u2019re problem solvers and learners. We thrive on challenge. If you have an idea you can\'t quite bring to life, come and say hi.'
	      ),
	      _react2.default.createElement(
	        _Tag2.default,
	        null,
	        'Or maybe you just want a new product to look ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/see/' },
	          'amazing...'
	        )
	      ),
	      _react2.default.createElement(
	        _Cta2.default,
	        { to: '/subscribe/' },
	        'follow us'
	      )
	    ),
	    _react2.default.createElement(
	      _Section2.default,
	      { style: { height: '110vh' } },
	      _react2.default.createElement(
	        _BackgroundMobile2.default,
	        null,
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: data.hero.mobile,
	          position: 'relative',
	          alt: 'Grill on Deck',
	          style: {
	            height: '100vh'
	          }
	        })
	      ),
	      _react2.default.createElement(
	        _BackgroundTablet2.default,
	        null,
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: data.hero.tablet,
	          position: 'relative',
	          alt: 'Grill on Deck',
	          style: {
	            height: '100vh'
	          }
	        })
	      ),
	      _react2.default.createElement(
	        _BackgroundWideScreen2.default,
	        null,
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: data.hero.widescreen,
	          position: 'relative',
	          alt: 'Grill on Deck',
	          style: {
	            height: '110vh'
	          }
	        })
	      ),
	      _react2.default.createElement(
	        _Content2.default,
	        null,
	        _react2.default.createElement(
	          _Cta2.default,
	          { to: '/subscribe/' },
	          'follow us'
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 727:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mirage.99e61545.mp4";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-d252eaf4215e7b7af7ca.js